import React, { useMemo } from 'react';
import { formaterPrix } from '../services/format';
import { getApiOrigin } from '../services/api';

export default function ArticlePanier({ item, onChangeQuantite, onSupprimer }) {
  const imageUrl = useMemo(() => {
    const raw = item?.image_url || null;
    if (!raw) return null;
    let s = String(raw);
    if (s.startsWith('/api/uploads')) {
      s = s.replace('/api/uploads', '/uploads');
    } else if (s.startsWith('api/uploads')) {
      s = s.replace('api/uploads', 'uploads');
    }
    if (s.startsWith('http://') || s.startsWith('https://')) return s;

    const origin = getApiOrigin().replace(/\/$/, '');

    if (s.startsWith('/uploads')) {
      return `${origin}${s}`;
    }

    if (s.startsWith('uploads/')) {
      return `${origin}/${s}`;
    }
    return s;
  }, [item?.image_url]);

  return (
    <div className="flex gap-4 rounded-2xl border border-gray-200 bg-white p-4">
      <div className="h-20 w-24 overflow-hidden rounded-xl bg-gray-100">
        {imageUrl ? (
          <img src={imageUrl} alt={item.nom} className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-[10px] text-slate-400">Aucune image</div>
        )}
      </div>
      <div className="flex-1">
        <div className="text-sm font-semibold text-gray-900">{item.nom}</div>
        <div className="mt-1 text-xs text-gray-500">{item.variante_libelle || ''}</div>
        <div className="mt-3 flex flex-wrap items-center gap-3">
          <div className="text-sm font-bold text-gray-900">{formaterPrix(item.prix_unitaire)}</div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => onChangeQuantite(Math.max(1, Number(item.quantite) - 1))}
              className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900 hover:bg-gray-100"
            >
              -
            </button>
            <div className="min-w-10 text-center text-sm text-gray-700">{item.quantite}</div>
            <button
              onClick={() => onChangeQuantite(Number(item.quantite) + 1)}
              className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900 hover:bg-gray-100"
            >
              +
            </button>
          </div>
          <button
            onClick={onSupprimer}
            className="ml-auto rounded-lg px-3 py-2 text-sm text-rose-700 hover:bg-rose-50"
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}
